import { render, staticRenderFns } from "./ManualTransferModal.vue?vue&type=template&id=7844fd2f&"
import script from "./ManualTransferModal.vue?vue&type=script&lang=js&"
export * from "./ManualTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports